

<div class="fc-content-category-host">
    <div class="fc-header-background"></div>
    <h1 [innerHtml]="page.heading | markedInline"></h1>
    <div class="fc-description" [innerHtml]="page.description | markedInline"></div>
    <fc-disclaimer *ngIf="disclosure?.message" [message]="disclosure?.message" [showLink]="showGenericLink"></fc-disclaimer>
</div>
<fc-content-container [page]="page"></fc-content-container>